import { render } from "./ViewRentalUserDetails.vue?vue&type=template&id=baff1f20"
import script from "./ViewRentalUserDetails.vue?vue&type=script&lang=js"
export * from "./ViewRentalUserDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__